import { Injectable } from '@angular/core';
import { ActivitiesAggrigatorModel } from '@shared/model/activities-aggrigator-model';
import { ActivityVerbEnum } from '@shared/model/enum/activity-verb-enum';
import { INotifTextStrategy } from '../model/notification.model';

@Injectable({
  providedIn: 'root'
})
export class ActivityTextStrategy implements INotifTextStrategy {
  public createText(activity: ActivitiesAggrigatorModel): string {
    return this.getOthersActivityText(activity);
  }


  // Original activities (user created content)
  private getOthersActivityText(
    activity: ActivitiesAggrigatorModel,
  ): string {
    const verb = activity?.verb ?? ActivityVerbEnum.Posted;

    switch (verb) {
      case ActivityVerbEnum.Quoted:
        return `بریدۀ کتاب منتشر کرد.`;

      case ActivityVerbEnum.Posted:
        return `پست منتشر کرد.`;

      case ActivityVerbEnum.Reviewed:
        return this.getReviewText(activity?.inDirectObject?.data);

      case ActivityVerbEnum.Rated:
        return this.getReviewText(activity?.inDirectObject?.data);

      case ActivityVerbEnum.Booklisted:
        return 'لیست منتشر کرد.';

      case ActivityVerbEnum.UserReportPublished:
        return `گزارش سالیانه‌ی خود را منتشر کرد.`;

      case ActivityVerbEnum.StateChangedToRead:
        return 'کتاب را تمام کرد.';

      case ActivityVerbEnum.StateChangedIWantToRead:
        return 'می‌خواهد بخواند.';

      case ActivityVerbEnum.StateChangedToCurrently:
        return 'شروع به مطالعه کرد.';

      case ActivityVerbEnum.ReadingProgressed:
        if (activity?.inDirectObject?.data?.steps > 0 && activity?.inDirectObject?.data?.steps != activity?.inDirectObject?.data?.totalPages) {
          return `تا صفحۀ ${activity.inDirectObject?.data?.steps} خواند.`;
        }
        if (activity?.inDirectObject?.data?.steps == -1) {
          return 'می‌خواهد بخواند.';
        }
        if (activity?.inDirectObject?.data?.steps == activity?.inDirectObject?.data?.totalPages) {
          return 'کتاب را تمام کرد.';
        }
        return '';


      case ActivityVerbEnum.AchievementObtained:
        return 'مدال گرفت';

      case ActivityVerbEnum.ChallengeObtained:
        return 'چالش را تمام کرد.';

      case ActivityVerbEnum.ChallengePicked:
        return 'به چالش پیوست.';

      case ActivityVerbEnum.Clubed:
        return 'باشگاه ساخت.';




      default:
        return '';
    }
  }


  private getReviewText(data: any): string {
    const hasBody = data?.body || data?.body?.length === 0;
    const hasRate = data?.rate > 0;
    return !hasBody && hasRate ? `امتیاز داد.` : `یادداشت نوشت.`;
  }
}
